import { INucDropdownItem } from '@relayter/rubber-duck';
import { autoserialize } from 'cerialize';

export class UserModel implements INucDropdownItem {
    @autoserialize public _id: string;
    @autoserialize public fullName: string;
    @autoserialize public email: string;
    @autoserialize public acceptPolicy: boolean;
    @autoserialize public acceptTracking: boolean;

    /**
     * IDropdownItem implementation
     * @returns {string}
     */
    public getTitle(): string {
        return this.fullName + ' - ' + this.email;
    }

    /**
     * IDropdownItem implementation
     * @returns {string}
     */
    public getValue(): string {
        return this._id;
    }
}
